module.exports = __webpack_public_path__ + "static/media/29.3d17856e.jpg";